export default __webpack_public_path__ + "static/media/IBZ.59b98355.png";